module.exports = __webpack_public_path__ + "img/oaknest-6.bcb90ade.jpeg";